import { render } from "./SiteBudgetReport.vue?vue&type=template&id=8e99db58&ts=true&lang=pug"
import script from "./SiteBudgetReport.vue?vue&type=script&lang=ts"
export * from "./SiteBudgetReport.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__